export default __webpack_public_path__ + "static/media/projectThumb1.2047e543.png";